module.exports = __webpack_public_path__ + "bonaire.svg?630eefd4e057e6aa4df240ab8f0eb7cc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/bonaire.svg
// module id = 114
// module chunks = 10